import React from "react";
import { Link } from "react-router-dom";
import { Box, Divider } from "@mui/material";
import StorefrontIcon from "@mui/icons-material/Storefront";

import ResultItem from "./ResultItem";

const VendorResult = ({ vendors = [] }) => {
  return (
    <Box>
      <div className="mb-2 px-5 font-semibold">Vendors</div>

      {vendors.map((vendor, index) => (
        <Link
          to={`/app/crm/vendor-profile/${vendor?._id}/detail`}
          key={vendor?._id}
        >
          <ResultItem
            title={vendor.shopName || vendor.ownerName}
            subtitle={vendor.shopName}
            icon={() => <StorefrontIcon color="primary" />}
          />

          {index !== vendors.length - 1 && <Divider />}
        </Link>
      ))}
    </Box>
  );
};

export default VendorResult;
 